import requests from './request'

// const httpUrl = 'http://192.168.1.28:10000/saas'
// const httpUrl = 'http://172.18.0.132:10000/saas'
const httpUrl = 'https://p.lietousaas.com/saas'

// 用户注册 不用删除！！！！
export const reqUserRegister = (data) => {
    return requests({
        url: httpUrl + '/zysp/auth/register',
        data,
        method: 'post',
    });
}

/* pc端 注册-登录 */
export function postPCLoginApi(params) {
    return requests({
        url: httpUrl + `/zysp/user/pc/login`,
        method: 'post',
        token: false,
        data: params
    })
}

/* 退出登录 */
export function postAccountLogoutApi() {
    return requests({
        url: httpUrl + '/account/logout',
        method: 'delete',
    })
}

/* 发送登录短信验证码 */
export function postSmsCodeApi(params) {
    return requests({
        url: httpUrl + `/zysp/user/sms/code`,
        method: 'post',
        token: false,
        data: params
    })
}

// 获取验证图片
export const postCaptchaGetApi = (data) => {
    return requests({
        url: httpUrl + '/zysp/captcha/get',
        method: 'post',
        token: false, // 判断请求头加token
        data,
    })
}

// 滑动或者点选验证
export const postCaptchaCheckApi = (data) => {
    return requests({
        url: httpUrl + '/zysp/captcha/check',
        method: 'post',
        token: false, // 判断请求头加token
        data,
    })
}

/* 职位列表 */
export function getJobListApi(params) {
    return requests({
        url: httpUrl + `/zysp/job`,
        method: 'get',
        token: false, // 判断请求头加token
        params: params
    })
}

/* 获取用户信息 */
export function getUserInfoApi() {
    return requests({
        url: httpUrl + `/zysp/user/info`,
        method: 'get',
    })
}

/* 获取职位详情 */
export function getJobIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/job/${id}`,
        method: 'get',
        token: false,
    })
}

/* 获取职位筛选条件 */
export function getJobConditionsApi(params) {
    return requests({
        url: httpUrl + `/zysp/job/conditions`,
        method: 'get',
        token: false,
        params: params
    })
}

/* 获取城市列表 */
export function getSystemAreasApi(param) {
    return requests({
        url: httpUrl + '/zysp/system/areas',
        method: 'get',
        token: false, // 请求头可以不加token
        params: param
    })
}

/* 获取子地区 */
export function getSystemAreaIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/system/area/${id}`,
        method: 'get',
        token: false, // 请求头可以不加token
    })
}

/* 获取所有职能 */
export function getSystemFunctionsApi() {
    return requests({
        url: httpUrl + `/zysp/system/functions`,
        method: 'get',
        token: false, // 请求头可以不加token
    })
}

/* 获取所有职能 */
export function getSystemIndustryApi() {
    return requests({
        url: httpUrl + `/zysp/system/industry`,
        method: 'get',
        token: false, // 请求头可以不加token
    })
}

/* 更新用户信息 */
export function postUserUpdateApi(params) {
    return requests({
        url: httpUrl + `/zysp/user/update`,
        method: 'post',
        data: params
    })
}

/* 上传简历附件 */
export function postResumeFileApi(params) {
    return requests({
        url: httpUrl + `/zysp/resume/file`,
        method: 'post',
        params: params
    })
}

/* 通用文件上传 */
export function postSystemUploadApi(params) {
    return requests({
        url: httpUrl + `/zysp/system/upload`,
        method: 'post',
        params: params
    })
}

/* 简历列表 */
export function getResumeFileApi() {
    return requests({
        url: httpUrl + `/zysp/resume/file`,
        method: 'get',
    })
}

/* 删除简历附件 */
export function getResumeFileIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/resume/file/${id}`,
        method: 'delete',
    })
}

/* 获取在线简历 */
export function getResumeOnlineApi() {
    return requests({
        url: httpUrl + `/zysp/resume/online/get`,
        method: 'get',
    })
}

/* 解析指定简历附件 */
export function postResumeFileParseIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/resume/file/parse/${id}`,
        method: 'post',
    })
}

/* 文件重命名 */
export function postResumeFileNameApi(params) {
    return requests({
        url: httpUrl + `/zysp/resume/file`,
        method: 'post',
        params: params
    })
}

/* 投递反馈 */
export function getOrderListApi(params) {
    return requests({
        url: httpUrl + `/zysp/order`,
        method: 'get',
        params: params
    })
}

/* 标记职位为感兴趣 */
export function postJobLikeIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/job/like/${id}`,
        method: 'post',
    })
}

/* 标记职位为不感兴趣 */
export function delJobLikeIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/job/like/${id}`,
        method: 'delete',
    })
}

/* 获取热搜词 */
export function getJobHotKwdListApi() {
    return requests({
        url: httpUrl + `/zysp/job/hot-kwd/list`,
        method: 'get',
        token: false, // 请求头可以不加token
    })
}

/* 获取相关职位数量 */
export function getJobStcCntApi() {
    return requests({
        url: httpUrl + `/zysp/job/stc-cnt`,
        method: 'get',
    })
}

/* banner列表 */
export function getAdByTypeApi(type) {
    return requests({
        url: httpUrl + `/zysp/ad/by-type/${type}`,
        method: 'get',
    })
}

/* 会话列表 */
export function getChatSessionsListApi(params) {
    return requests({
        url: httpUrl + `/zysp/chat/sessions`,
        method: 'get',
        params: params
    })
}

/* 置顶会话 */
export function postChatSessionsFixTopIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/chat/session/fix-top/${id}`,
        method: 'post',
    })
}

/* 取消置顶会话 */
export function postChatSessionsUnFixTopIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/chat/session/un-fix-top/${id}`,
        method: 'post',
    })
}

/* 删除会话 */
export function delChatIdApi(id) {
    return requests({
        url: httpUrl + `/zysp/chat/${id}`,
        method: 'delete',
    })
}

/* 获取未读消息数量 */
export function getChatUnreadCntApi() {
    return requests({
        url: httpUrl + `/zysp/chat/unread-cnt`,
        method: 'get',
    })
}

/* 获取指定会话的消息 */
export function getChatMessagesApi(params) {
    return requests({
        url: httpUrl + `/zysp/chat/messages`,
        method: 'get',
        params: params
    })
}

/* 创建会话 */
export function postZyspChatSessionApi(param) {
    return requests({
        url: httpUrl + `/zysp/chat/session/${param}`,
        method: 'post',
        headers: { 'ContentType': 'application/json' },
        data: param
    })
}

/* =========================================================================
 * 校园招聘 (Campus Recruitment) - 求职者端/前台 API
 * ========================================================================= */

/* 获取校招门户装潢配置及有效活动列表 */
export function getRecruitmentPortalLayoutApi(subdomain) {
    return requests({
        url: httpUrl + `/hr/recruitment/auth/portal/layout`,
        method: 'get',
        token: false,
        params: { subdomain }
    })
}

/* 候选人手机号验证码登录 */
export function postRecruitmentLoginApi(params) {
    return requests({
        url: httpUrl + `/hr/recruitment/auth/login`,
        method: 'post',
        token: false,
        data: params
    })
}

/* 获取特定校招活动详情及其报名字段配置 */
export function getRecruitmentEventDetailApi(eventId) {
    return requests({
        url: httpUrl + `/hr/recruitment/auth/event/${eventId}`,
        method: 'get',
        token: false
    })
}

/* 获取校招职位列表及筛选条件 */
export function getRecruitmentJobsApi(subdomain, params) {
    return requests({
        url: httpUrl + `/hr/recruitment/auth/jobs`,
        method: 'get',
        token: false,
        params: { subdomain, ...params }
    })
}

/* 提交校招活动报名表单 */
export function postRecruitmentApplyApi(eventId, params) {
    return requests({
        url: httpUrl + `/hr/recruitment/candidate/event/${eventId}/apply`,
        method: 'post',
        data: params
    })
}

/* 获取当前登录候选人需要参加的所有测试任务（考试与测评） */
export function getRecruitmentMyTestsApi() {
    return requests({
        url: httpUrl + `/hr/recruitment/candidate/my/tests`,
        method: 'get'
    })
}

